export const AI_ASSISTANT_GUTTER_TRANSITION = 'padding-right 220ms ease-out';
